import React from "react";
import { accentMap, formatNumber } from "./financialUtils";

export default function FinancialKpis({ kpis = [] }) {
  return (
    <div className="row g-3">
      {kpis.map((kpi) => (
        <div className="col-12 col-sm-6 col-lg-3" key={kpi.label}>
          <div className="admin-kpi-card h-100">
            <div className="admin-kpi-body">
              <span
                className="admin-kpi-icon"
                style={{
                  backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                  color: accentMap[kpi.accent]?.fg || "#0f172a",
                }}
              >
                <i className={`bi ${kpi.icon || "bi-cash-coin"} me-0`} />
              </span>
              <div className="admin-kpi-text">
                <p className="admin-kpi-label mb-0">{kpi.label}</p>
                <div className="admin-kpi-value">{formatNumber(kpi.value, kpi.isMoney)}</div>
                <div className="admin-kpi-helper">{kpi.helper}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
